import React, { Fragment } from 'react';

import { FieldArray, Formik } from 'formik';
import * as PropTypes from 'prop-types';

import KeyDatesInputsGrid from '../procurement_plan/KeyDatesInputsGrid';
import ProcurementAttachments from '../procurement_plan/ProcurementAttachments';
import ProcurementExpenseTable from '../procurement_plan/ProcurementExpenseTable';
import TendererField from '../procurement_plan/TendererField';

import { formatToFixedMoneyWithLocale } from 'Helpers/formatService';

import FormHorizontalSeparator from 'CommonComponents/FormHorizontalSeparator';
import FormSectionHeading from 'CommonComponents/FormSectionHeading';
import LoadingSpinner from 'CommonComponents/LoadingSpinner';
import ModalHeader from 'CommonComponents/ModalHeader';
import MultiUserSelectorInput from 'CommonComponents/MultiUserSelectorInput';
import TextareaFormField from 'CommonComponents/TextareaFormField';
import TextFormField from 'CommonComponents/TextFormField';

import { useUsers } from 'Hooks/useUsers';

function KeyDatesInputsGrids(props) {
    return null;
}

KeyDatesInputsGrids.propTypes = {
    touched: PropTypes.any,
    setFieldValue: PropTypes.func,
    values: PropTypes.any,
    disabled: PropTypes.bool,
    errors: PropTypes.any,
};
export default function ProcurementApprovalsItemInfoModal(props) {
    const { users } = useUsers();

    return (
        <div id="procurement-item-info-modal" ref={props.modalRef} tabIndex="-1" aria-hidden="true" className="hidden modal__box">
            <div className="modal__container">
                <div className="modal__inner-container">
                    <ModalHeader title={$t('Procurement Info')} close={props.onClose}></ModalHeader>
                    <div className="tw-rounded-b">
                        {props.loading ? (
                            <LoadingSpinner />
                        ) : (
                            <div className="modal__form-container">
                                <Formik
                                    enableReinitialize
                                    initialValues={{
                                        name: props.procurement?.name || '',
                                        description: props.procurement?.description || '',
                                        owner_id: props.procurement?.owner_id || '',
                                        priority: props.procurement?.priority?.toString() || '',
                                        complexity: props.procurement?.complexity?.toString() || '',
                                        additional_category: props.procurement?.additional_category || '',
                                        pr_number: props.procurement?.pr_number || '',
                                        po_number: props.procurement?.po_number || '',
                                        target_scope_issue_to_market_date: props.procurement?.target_scope_issue_to_market_date || '',
                                        expected_scope_issue_to_market_date: props.procurement?.expected_scope_issue_to_market_date || '',
                                        actual_scope_issue_to_market_date: props.procurement?.actual_scope_issue_to_market_date || '',
                                        target_response_due_date: props.procurement?.target_response_due_date || '',
                                        expected_response_due_date: props.procurement?.expected_response_due_date || '',
                                        actual_response_due_date: props.procurement?.actual_response_due_date || '',
                                        target_decision_date: props.procurement?.target_decision_date || '',
                                        expected_decision_date: props.procurement?.expected_decision_date || '',
                                        actual_decision_date: props.procurement?.actual_decision_date || '',
                                        target_contract_award_date: props.procurement?.target_contract_award_date || '',
                                        expected_contract_award_date: props.procurement?.expected_contract_award_date || '',
                                        actual_contract_award_date: props.procurement?.actual_contract_award_date || '',
                                        target_contract_completion_date: props.procurement?.target_contract_completion_date || '',
                                        expected_contract_completion_date: props.procurement?.expected_contract_completion_date || '',
                                        actual_contract_completion_date: props.procurement?.actual_contract_completion_date || '',
                                        policy_id: props.procurement?.policy_id || '',
                                        category_id: props.procurement?.category_id || '',
                                        procurement_status_id: props.procurement?.procurement_status_id || '',
                                        tenderers: props.procurement?.tenderers || [],
                                        evaluator_ids: props.procurement?.evaluator_ids || [],
                                        attachments: props.procurement?.attachments || [],
                                    }}
                                >
                                    {({ values, errors, touched, isSubmitting, handleSubmit, setFieldValue }) => (
                                        <>
                                            <form
                                                // style={{ display: !showExpenseSelection ? 'block' : 'none' }}
                                                className="tw-transition tw-ease-in-out tw-delay-150 tw-duration-300 modal__form-container"
                                            >
                                                <FormSectionHeading heading={$t('Summary')}></FormSectionHeading>
                                                <div className="tw-grid tw-grid-cols-2 tw-gap-4">
                                                    <div className="tw-flex tw-flex-col tw-space-y-4">
                                                        <TextFormField label={$t('Name')} type="text" name="name" disabled></TextFormField>
                                                        <TextareaFormField
                                                            label={$t('Description')}
                                                            as="textarea"
                                                            type="text"
                                                            name="description"
                                                            disabled
                                                        ></TextareaFormField>
                                                        <div className="tw-flex tw-flex-col tw-space-y-1.5">
                                                            <label className="text-input__label">{$t('Value')}</label>
                                                            <input
                                                                type="text"
                                                                className="tw-border-0 text-input"
                                                                value={formatToFixedMoneyWithLocale(props.procurement?.value) || ''}
                                                                disabled
                                                            />
                                                        </div>
                                                        <div className="tw-flex tw-flex-col tw-space-y-1.5">
                                                            <label className="text-input__label">{$t('Procurement Category')}</label>
                                                            <input
                                                                type="text"
                                                                className="tw-border-0 text-input"
                                                                value={props.procurement?.procurement_category?.name || ''}
                                                                disabled
                                                            />
                                                        </div>
                                                        <TextFormField
                                                            label={$t('Additional Procurement Category')}
                                                            type="text"
                                                            name="additional_category"
                                                            disabled
                                                        ></TextFormField>
                                                        <div className="tw-flex tw-flex-col tw-space-y-1.5">
                                                            <label className="text-input__label">{$t('PR Number')}</label>
                                                            <input
                                                                type="text"
                                                                className="tw-border-0 text-input"
                                                                value={props.procurement?.purchase_requisition?.pr_code || ''}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="tw-flex tw-flex-col tw-space-y-4">
                                                        <div className="tw-flex tw-flex-col tw-space-y-1.5">
                                                            <label htmlFor="owner_id" className="text-input__label">
                                                                {$t('Owner')}
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="tw-border-0 text-input"
                                                                value={
                                                                    props.procurement?.owner
                                                                        ? props.procurement.owner.first_name + ' ' + props.procurement.owner.last_name
                                                                        : ''
                                                                }
                                                                disabled
                                                            />
                                                        </div>
                                                        <div className="tw-flex tw-flex-col tw-space-y-1.5">
                                                            <label className="text-input__label">{$t('Status')}</label>
                                                            <input
                                                                type="text"
                                                                className="tw-border-0 text-input"
                                                                value={props.procurement?.procurement_status?.title || ''}
                                                                disabled
                                                            />
                                                        </div>
                                                        <div className="tw-flex tw-flex-col tw-space-y-1.5">
                                                            <label className="text-input__label">{$t('Procurement Policy')}</label>
                                                            <input
                                                                type="text"
                                                                className="tw-border-0 text-input"
                                                                value={props.procurement?.procurement_policy?.method || ''}
                                                                disabled
                                                            />
                                                        </div>
                                                        <div className="tw-flex tw-flex-col tw-space-y-1.5">
                                                            <label className="text-input__label">{$t('Priority')}</label>
                                                            <input
                                                                type="text"
                                                                className="tw-border-0 text-input"
                                                                value={props.procurement?.priority_label || ''}
                                                                disabled
                                                            />
                                                        </div>
                                                        <div className="tw-flex tw-flex-col tw-space-y-1.5">
                                                            <label className="text-input__label">{$t('Complexity')}</label>
                                                            <input
                                                                type="text"
                                                                className="tw-border-0 text-input"
                                                                value={props.procurement?.complexity_label || ''}
                                                                disabled
                                                            />
                                                        </div>
                                                        <div className="tw-flex tw-flex-col tw-space-y-1.5">
                                                            <label className="text-input__label">{$t('PO Number')}</label>
                                                            <input
                                                                type="text"
                                                                className="tw-border-0 text-input"
                                                                value={props.procurement?.purchase_order?.code || ''}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <FormHorizontalSeparator disabled />

                                                <KeyDatesInputsGrid
                                                    values={values}
                                                    errors={errors}
                                                    touched={touched}
                                                    setFieldValue={setFieldValue}
                                                    disabled={true}
                                                />

                                                <FormHorizontalSeparator disabled />

                                                <div className="tw-flex tw-flex-col tw-space-y-4">
                                                    <FieldArray name="tenderers">
                                                        {(arrayHelpers) => (
                                                            <>
                                                                <div className="tw-flex tw-flex-row tw-justify-between tw-items-center">
                                                                    <FormSectionHeading heading={$t('Possible Tenderers')}></FormSectionHeading>
                                                                </div>

                                                                {!!values.tenderers?.length &&
                                                                    values.tenderers.map((tenderer, index) => {
                                                                        const tendererErrors = (errors?.tenderers || [])[index];
                                                                        const tendererTouched = (touched?.tenderers || [])[index];

                                                                        return (
                                                                            <Fragment key={index}>
                                                                                <TendererField
                                                                                    name={`tenderers.${index}`}
                                                                                    errors={tendererErrors}
                                                                                    touched={tendererTouched}
                                                                                    disabled={true}
                                                                                    actions={null}
                                                                                />
                                                                            </Fragment>
                                                                        );
                                                                    })}
                                                            </>
                                                        )}
                                                    </FieldArray>
                                                </div>
                                                <FormHorizontalSeparator disabled={props.isCreatePrMode} />

                                                <div className="tw-grid tw-grid-cols-1">
                                                    <div className="tw-flex tw-flex-col tw-space-y-1.5">
                                                        <label className="text-input__label" htmlFor="evaluator_ids">
                                                            {$t('Evaluators')}
                                                        </label>
                                                        <MultiUserSelectorInput
                                                            className="react-select-container"
                                                            classNamePrefix="react-select"
                                                            isMulti
                                                            selectedIds={values.evaluator_ids}
                                                            usersList={users}
                                                            onChange={(value) => {}}
                                                            disabled
                                                        />
                                                    </div>
                                                </div>

                                                <FormHorizontalSeparator disabled />
                                                <FormSectionHeading heading={$t('Attachments')}></FormSectionHeading>
                                                {!!props.procurement?.attachments?.length && (
                                                    <ProcurementAttachments
                                                        procurement={props.procurement}
                                                        attachments={props.procurement.attachments}
                                                        onDelete={() => {}}
                                                        disabled={true}
                                                        canDelete={false}
                                                        downloadAttachmentUrl={props.downloadAttachmentUrl}
                                                    />
                                                )}

                                                <FormHorizontalSeparator disabled />
                                                <div className="tw-flex tw-flex-row tw-justify-between tw-items-center">
                                                    <FormSectionHeading heading={$t('Budget Line Items')}></FormSectionHeading>
                                                </div>

                                                <ProcurementExpenseTable
                                                    expensesTree={props.procurement?.expenses_tree}
                                                    total={props.procurement?.expenses_tree?.total}
                                                    maxQuantities={props.procurement?.expenses_tree?.max_quantities}
                                                    removable={false}
                                                />
                                            </form>
                                        </>
                                    )}
                                </Formik>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
